import { render, staticRenderFns } from "./TrolleyIcon.vue?vue&type=template&id=33feb541"
import script from "./TrolleyIcon.vue?vue&type=script&lang=js"
export * from "./TrolleyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports